import 'easy-autocomplete/dist/jquery.easy-autocomplete';
const expression   = /[ąćęłńóśźż]/gi;
const replacements = {
    'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
    'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N', 'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
};
const replacePolishLetters = (text) => {
    return text.replace(expression, (letter) => replacements[letter]);
};

function searchForProducts() {
    // $('[data-open-search-popup]').on('click', function () {
    //     $('.search-popup').addClass('show');
    // });
    // $('[data-close-search-popup]').on('click', function () {
    //     $('.search-popup').removeClass('show');
    // });
    const dataTemplate = document.body.dataset.template;
    console.log(dataTemplate);
    const options = {
        url: dataTemplate + '/lp-mocarny/data/search.json',
        getValue: "searchValue",
        categories: [
          {
                listLocation: "products",
                maxNumberOfElements: 10,
                header: "W tym punkcie skorzystasz z naszej promocji!"
            }
        ],
        list: {
            maxNumberOfElements: 15,
            match: {
                enabled: true,
                method: function (element, phrase) {
                    // phrase = replacePolishLetters(phrase.toLocaleLowerCase());
                    const phrases = phrase.split(' ');
                    return phrases.reduce((prev, curr) => {
                        if (!prev) return false;
                        return element.includes(curr);
                    }, true);
                },
            },

            // onSelectItemEvent:function() {
            //     setGlobalSearchInputValue();
            //     return false;
            // },
            // onChooseEvent:function() {
            //     return false;
            // },
            // onKeyEnterEvent:function() {
            //     $('.search-popup__input').val(globalSearchInputValue);
            //     return false;
            // },
            // onMouseOutEvent:function() {
            //     setGlobalSearchInputValue();
            //     return false;
            // },
        },
        highlightPhrase: false,
        template: {
            type: "custom",
            method: function (value, item) {
                    return (
                        '<a href="https://maps.google.com/maps/search/?api=1&query='+item.names+'" class="search__item">' +
                        '<div class="item__image-wrapper">' +
                        '<span class="item__name">' + item.names + '</span>' +
                        '<span class="item__place">' + item.place + '</span>' +
                        '</div>' +
                        '</a>'
                    );
            }
        }
    };
    $('.search-machine').easyAutocomplete(options);
}


export default {
    searchForProducts,
};



// WEBPACK FOOTER //
// ./src/scripts/search.js